var NOTIFICATION_STATE;
(function (NOTIFICATION_STATE) {
    NOTIFICATION_STATE["NONE"] = "none";
    NOTIFICATION_STATE["NEW"] = "new";
    NOTIFICATION_STATE["NUMBER"] = "number";
    NOTIFICATION_STATE["DOT"] = "dot";
})(NOTIFICATION_STATE || (NOTIFICATION_STATE = {}));
var ITEM_STATE;
(function (ITEM_STATE) {
    ITEM_STATE["DEFAULT"] = "default";
    ITEM_STATE["ACTIVE"] = "active";
    ITEM_STATE["LOADING"] = "loading";
})(ITEM_STATE || (ITEM_STATE = {}));
var ITEM_VARIANT;
(function (ITEM_VARIANT) {
    ITEM_VARIANT["DEFAULT"] = "default";
    ITEM_VARIANT["MINI"] = "mini";
})(ITEM_VARIANT || (ITEM_VARIANT = {}));

export { ITEM_VARIANT as I, NOTIFICATION_STATE as N, ITEM_STATE as a };
